import { DE_XUAT_MUA_SAM_API } from "constants/ApiConstant";
import axiosInstance from "auth/FetchInterceptor";
const DeXuatMuaSamService = {};

DeXuatMuaSamService.GetAllDeXuatMuaSam = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/get-all`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetAllDeXuatMuaSamMp = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/get-all-Mp`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetAllTongHopDeXuatMuaSam = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/getall-tonghop`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};
DeXuatMuaSamService.GetDeXuatMuaSam = function (data) {
    return axiosInstance.get(
        `${DE_XUAT_MUA_SAM_API}/get-by-id?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};
DeXuatMuaSamService.GetAllChuaTongHopChiTiet = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/get-chuatonghop-chitiet`, data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};
DeXuatMuaSamService.GetAllTongHopChiTiet = function (data) {
    return axiosInstance.get(
        `${DE_XUAT_MUA_SAM_API}/get-tonghop-chitiet?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetTongHopDeXuatMuaSam = function (data) {
    return axiosInstance.get(
        `${DE_XUAT_MUA_SAM_API}/get-tonghop?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};
DeXuatMuaSamService.UpsertDeXuatMuaSam = function (data) {
    return axiosInstance.put(
        `${DE_XUAT_MUA_SAM_API}/upsert`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.UpsertTrangThaiDx = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/upsert-trangthai`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.IsTongHopChiTiet = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/is-tonghop-chitiet`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.UpdateTongHopChiTiet = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/update-tonghop-chitiet`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.UpdateTrangThaiTongHopChiTiet = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/update-trangthai-tonghop-chitiet`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.DeleteDeXuatMuaSam = function (data) {
    return axiosInstance.delete(
        `${DE_XUAT_MUA_SAM_API}/delete?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.DeleteTongHopDeXuatMuaSam = function (data) {
    return axiosInstance.delete(
        `${DE_XUAT_MUA_SAM_API}/delete-tonghop?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetDeXuatMuaSamChiTiet = function (data) {
    return axiosInstance.get(
        `${DE_XUAT_MUA_SAM_API}/getall-detail?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.UpsertDeXuatMuaSamChiTiet = function (data) {
    return axiosInstance.put(
        `${DE_XUAT_MUA_SAM_API}/upsert-chitiet`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.DeleteDeXuatMuaSamChiTiet = function (data) {
    return axiosInstance.delete(
        `${DE_XUAT_MUA_SAM_API}/delete-chitiet?id=${data}`,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetListTaiSanByLoaiDC = function (data) {
    return axiosInstance.post(
        `${DE_XUAT_MUA_SAM_API}/get-list-tai-san-theo-loai`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};

DeXuatMuaSamService.GetAllTaiSan = function () {
    return axiosInstance.get(`${DE_XUAT_MUA_SAM_API}/get-all-list-tai-san`, {
        baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
    });
};


DeXuatMuaSamService.GetAllChuaTongHop = function (data) {
    return axiosInstance.get(`${DE_XUAT_MUA_SAM_API}/get-dexuat-tonghop?id=${data}`, {
        baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
    });
};

DeXuatMuaSamService.UpsertTongHopDeXuatMuaSam = function (data) {
    return axiosInstance.put(
        `${DE_XUAT_MUA_SAM_API}/upsert-tonghop`,
        data,
        {
            baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
        }
    );
};


DeXuatMuaSamService.ExportTongHopDxms = function (data) {
    return axiosInstance.post(`${DE_XUAT_MUA_SAM_API}/tong-hop-export-excel?TongHopId=${data.tongHopId}`, data, {
        baseURL: process.env.REACT_APP_ASSET_ENDPOINT_URL,
    });
};
export default DeXuatMuaSamService;
